import{c as t}from"../chunk-AQQ67SAX.mjs";import"../chunk-MU4WOLM6.mjs";import{b as e}from"../chunk-VTRYZJDB.mjs";var l=e.createGlobalStyle`
  ${""}

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  ${""}

  html {
    line-height: 1.15; /* 1 */
    -webkit-text-size-adjust: 100%; /* 2 */
  }

  ${""}

  body {
    margin: 0; /* 1 */
    -webkit-text-size-adjust: 100%; /* 2 */
    -webkit-tap-highlight-color: rgba($black, 0); /* 3 */
  }

  ${""}

  main {
    display: block;
  }

  ${""}

  hr {
    box-sizing: content-box; /* 1 */
    height: 0; /* 1 */
    overflow: visible; /* 2 */
  }

  ${""}

  [tabindex='-1']:focus:not(:focus-visible) {
    outline: 0 !important;
  }

  ${""}

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: 1.15; /* 1 */
    margin: 0; /* 2 */
  }

  ${""}

  button,
  input {
    /* 1 */
    overflow: visible;
  }

  ${""}

  button,
  select {
    /* 1 */
    text-transform: none;
  }

  ${""}

  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    -webkit-appearance: button;
  }

  ${""}

  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  ${""}

  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }

  ${""}

  legend {
    box-sizing: border-box; /* 1 */
    color: inherit; /* 2 */
    display: table; /* 1 */
    max-width: 100%; /* 1 */
    padding: 0; /* 3 */
    white-space: normal; /* 1 */
  }

  ${""}

  progress {
    vertical-align: baseline;
  }

  ${""}

  textarea {
    overflow: auto;
  }

  ${""}

  [type='checkbox'],
  [type='radio'] {
    box-sizing: border-box; /* 1 */
    padding: 0; /* 2 */
  }

  ${""}

  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }

  ${""}

  [type='search'] {
    -webkit-appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
  }

  ${""}

  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  ${""}

  ::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
  }

  ${""}

  details {
    display: block;
  }

  ${""}

  summary {
    display: list-item;
  }

  ${""}

  template {
    display: none;
  }

  ${""}

  [hidden] {
    display: none;
  }

  ${""}

  abbr[title],
  abbr[data-original-title] /* 1 */ {
    text-decoration: underline; /* 2 */
    text-decoration: underline dotted; /* 2 */
    cursor: help; // 3
    text-decoration-skip-ink: none; /* 4 */
  }

  ${""}

  address {
    font-style: normal;
    line-height: inherit;
  }

  ${""}

  dt {
    font-weight: $dt-font-weight;
  }

  ${""}

  sub,
  sup {
    position: relative;
    line-height: 0;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  ${""}

  a:not([href]):not([class]) {
    &,
    &:hover {
      color: inherit;
      text-decoration: none;
    }
  }

  ${""}

  pre {
    display: block;
    overflow: auto; // 1
    -ms-overflow-style: scrollbar; // 2

    ${""}
    code {
      color: inherit;
      word-break: normal;
    }
  }

  code {
    word-wrap: break-word;

    ${""}
    a > & {
      color: inherit;
    }
  }

  kbd {
    kbd {
      padding: 0;
    }
  }

  ${""}

  img,
  svg {
    vertical-align: middle;
  }

  ${""}

  table {
    caption-side: bottom;
    border-collapse: collapse;
  }

  caption {
    text-align: left;
  }

  ${""}

  th {
    text-align: inherit; /* 1 */
    text-align: -webkit-match-parent; /* 2 */
  }

  thead,
  tbody,
  tfoot,
  tr,
  td,
  th {
    border-color: inherit;
    border-style: solid;
    border-width: 0;
  }

  ${""}

  label {
    display: inline-block; /* 1 */
  }

  ${""}

  button {
    border-radius: 0;
  }

  ${""}

  button:focus {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color;
  }

  ${""}

  input,
  button,
  select,
  optgroup,
  textarea {
    margin: 0; /* 1 */
    font-family: inherit;
    line-height: inherit;
  }

  ${""}

  button,
  input {
    overflow: visible;
  }

  ${""}

  button,
  select {
    text-transform: none;
  }

  ${""}

  [role='button'] {
    cursor: pointer;
  }

  ${""}

  select {
    word-wrap: normal;
  }

  ${""}

  [list]::-webkit-calendar-picker-indicator {
    display: none;
  }

  ${""}

  button,
  [type="button"], /* 1 */
  [type="reset"],
  [type="submit"] {
    -webkit-appearance: button; /* 2 */

    &:not(:disabled) {
      cursor: pointer; /* 3 */
    }
  }

  ${""}

  textarea {
    resize: vertical; /* 1 */
  }

  ${""}

  fieldset {
    min-width: 0; /* 1 */
    padding: 0; /* 2 */
    margin: 0; /* 2 */
    border: 0; /* 2 */
  }

  ${""}

  legend {
    float: left; /* 1 */
    width: 100%;
    padding: 0;
    line-height: inherit;
    white-space: normal; /* 2 */

    + * {
      clear: left; /* 3 */
    }
  }

  ${""}

  ::-webkit-datetime-edit-fields-wrapper,
  ::-webkit-datetime-edit-text,
  ::-webkit-datetime-edit-minute,
  ::-webkit-datetime-edit-hour-field,
  ::-webkit-datetime-edit-day-field,
  ::-webkit-datetime-edit-month-field,
  ::-webkit-datetime-edit-year-field {
    padding: 0;
  }

  ::-webkit-inner-spin-button {
    height: auto;
  }

  ${""}

  [type='search'] {
    outline-offset: -2px; // 1
    -webkit-appearance: textfield; // 2
  }

  ${""}

  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  ${""}

  ::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  ${""}

  ::-webkit-file-upload-button {
    font: inherit; /* 1 */
    -webkit-appearance: button; /* 2 */
  }

  ${""}

  output {
    display: inline-block;
  }

  ${""}

  iframe {
    border: 0;
  }

  ${""}

  summary {
    display: list-item; /* 1 */
    cursor: pointer;
  }

  ${""}

  progress {
    vertical-align: baseline;
  }

  ${""}

  [hidden] {
    display: none !important;
  }
`,i=l;import{Fragment as b,jsx as o,jsxs as p}from"react/jsx-runtime";var d=n=>p(b,{children:[o(i,{}),o(t,{...n})]}),h=d;export{h as default};
